import {Suspense, useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ThemeModeProvider} from '../_metronic/partials'
import {useCompanyGroupDispatch} from './store/companyGroup'
import {useUserDispatch, useUserSelector} from './store/user'
import {pca} from './helpers/msal-config'
import {MsalProvider} from '@azure/msal-react'
import Loading from './components/Loading'

const App = () => {
  const location = useLocation()
  const {pathname} = location

  const {user, loading} = useUserSelector()
  const {getCompanyGroup} = useCompanyGroupDispatch()
  const {getUserProfile} = useUserDispatch()

  useEffect(() => {
    if (pathname.search('auth') > 0 || user) return
    if (localStorage.getItem('accessToken')) {
      localStorage.removeItem('redirect')
      getCompanyGroup()
      getUserProfile()
    } else {
      // console.log('location', `${location.pathname}${location.search}`)
      localStorage.setItem('redirect', `${location.pathname}${location.search}`)
      // console.log('http://localhost:3011/tasks/assign-tag?id=fdeaf173-9e04-4296-9d72-d609073a2b29')
    }
  }, [pathname])

  return (
    <MsalProvider instance={pca}>
      {loading && <Loading />}
      <Suspense fallback={<LayoutSplashScreen />}>
        {/* {user && ( */}
        <I18nProvider>
          <LayoutProvider>
            <ThemeModeProvider>
              <AuthInit>
                <Outlet />
                <MasterInit />
              </AuthInit>
            </ThemeModeProvider>
          </LayoutProvider>
        </I18nProvider>
        {/* )} */}
      </Suspense>
    </MsalProvider>
  )
}

export {App}
